module.exports = __webpack_public_path__ + "static/media/noOrder.3d837e76.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/noOrder.png
// module id = 19
// module chunks = 2